
import { CircularProgress } from "@mui/material";
import { Tabela, Tabler, TabelaCabeca, TabelaCorpo, CorpoTable } from "../../../../components/formulario/tableStyled";
import { useState, useEffect, lazy, Suspense } from "react";
import { useRef } from 'react';
import { UseListMembros } from "../context/ListMembros";

const Row = lazy(() => import('../rows'))

export default function TabelasMembrosPg() {

  const [filas, setFilas] = useState({ fila: 0, tamanho: 300 });
  const devRef = useRef(null) as any;
  const { list, params } = UseListMembros()

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          setFilas({ fila: filas.fila++, tamanho: filas.tamanho + 300 })
        }
      })
    }
  }, [devRef])


  return (
    <>
      <Tabler>
        <CorpoTable
          ref={devRef}>
          {
            params?.sede && (list?.length <= 0 || !list?.length) && (
              <>
                <div style={{ display: 'flex', position: 'absolute', top: '50%', left: '50%' }}>Necessário passar no mínimo uma sede em filtro para busca</div>
              </>
            )
          }
          <Tabela>
            <>
              <TabelaCabeca>
                <tr>
                  <th>Nome</th>
                  <th>Telefone</th>
                  <th>E-mail</th>
                  <th>Sede</th>
                  <th>PG</th>
                  <th>Cargo</th>
                  <th>
                  </th>
                </tr>
              </TabelaCabeca>
              <TabelaCorpo >
                <Suspense fallback={<CircularProgress />}>
                  <Row filas={filas} />
                </Suspense>
              </TabelaCorpo>
            </>
          </Tabela>
        </CorpoTable>
      </Tabler>
    </>
  )
}



/* <ListaAlteracaoCargo usuario={usuario} visivel={popUpAlteracaoUsuario?.match('cargo') ? true : false} close={setPopUpAlteracaoUsuario} /> */  // lista de cargos a
